import {
  FilterChip,
  FilterViewerComponentProps,
} from '@spotify/confidence-core-react';

import { useSurfaces } from '../../hooks';

const formatLabel = (value: string[]) => {
  if (value.length > 1) {
    return `Surfaces (${value.length})`;
  }

  if (value.length === 1) {
    return `Surface: ${value[0]}`;
  }

  return 'No surfaces';
};

export const SurfaceFilterViewer = (
  props: FilterViewerComponentProps<string[]>,
) => {
  const { value } = props;
  const { surfaces, nextPage, hasNextPage, isLoading } = useSurfaces();

  const surfaceNames = value.map(
    name => surfaces?.find(s => s.name === name)?.displayName ?? name,
  );

  const hasAllNames = value.every(name => !surfaceNames.includes(name));

  if (!hasAllNames && hasNextPage) {
    nextPage();
  }

  return (
    <FilterChip
      {...props}
      label={formatLabel(surfaceNames)}
      loading={isLoading}
    />
  );
};
